module.exports = __webpack_public_path__ + "static/media/no-items-found.4c70d996.png";